module.exports = __webpack_public_path__ + "static/media/frp-app-image4.e214ce9b.png";